export const Region = {
  MALAYSIA: "MY",
  INDO: "ID",
};

export const hideCompanyList = [
  "joker",
  "playtech",
  "ebet",
  "allbet",
  "dreamgaming",
  "evolutiongaming",
];

export const hideGameList = [
  "SMG_titaniumLiveGamesAutoRoulette",
  "SMG_titaniumLiveGames_Baccarat_Playboy",
  "SMG_titaniumLiveGames_Roulette_Playboy",
];

export const malaysiaDatabaseName = "ok99MemberMYR";
